var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin",attrs:{"id":"my-video","controls":"","playsinline":true,"preload":"metadata"}},[_c('source',{attrs:{"src":_vm.src,"type":"application/x-mpegURL"}})])}
var staticRenderFns = []

export { render, staticRenderFns }